export default __webpack_public_path__ + "static/media/photo--sm--66.744d7ba6.jpg";